<ng-container>
	<app-top-nav-bar-button
		id="matter-nav-documents"
		[icon]="'file-text'"
		title="Documents"
		[num]="documentCount$ | async"
		[testHook]="testHooks.MatterNavDocumentsButton"
		intercomTarget="matter-topnav-documents"
		(showing)="showDocumentsDropdown = $event"
	>
		<app-document-drop-down
			(onDocumentSelected)="showDocumentsDropdown = false"
		></app-document-drop-down>
	</app-top-nav-bar-button>
</ng-container>
